import { render } from "./NavigationButton.vue?vue&type=template&id=5816b5fa&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"

import "./NavigationButton.vue?vue&type=style&index=0&id=5816b5fa&lang=scss&scoped=true"

import exportComponent from "/builds/enforb/elena-front-deploy/elena-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5816b5fa"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QItem,QItemSection,QIcon,QBadge,QTooltip,QExpansionItem});qInstall(script, 'directives', {Ripple});
